.sideMenu {
	.menuHeader {
		@apply
		yst-flex
		yst-items-center
		lg:yst-items-start
		yst-justify-between
		lg:yst-flex-col
		yst-mt-10
		yst-mb-6
		lg:yst-px-4
		lg:yst-space-y-10
		lg:yst-mb-6;
	}
}

/*
 * Scoped to the two menu navs (desktop sidebar and portaled mobile dialog); a bare
 * `nav` selector is not module-scoped and would leak to every nav in the app,
 * such as the ui-library Pagination.
 */
nav.desktopMenu,
:global(.yst-mobile-navigation__dialog) nav {
	@apply
	yst-flex
	yst-flex-row
	yst-gap-2
	lg:yst-gap-0
	lg:yst-flex-col
	yst-overflow-x-auto
	yst-px-0.5;

	li {
		@apply yst-block;

		a {
			@apply
			yst-my-1.5;
		}

		[class~=active] {
			@apply
			yst-bg-white
			lg:yst-bg-slate-200;

			svg {
				@apply yst-text-slate-500;
			}

			&:hover {
				@apply yst-bg-slate-200 #{!important};
			}

			span {
				@apply yst-text-slate-900;
			}
		}
	}

	.menuItem,
	.menuItem[class~='yst-link'] {
		@apply
		yst-flex
		yst-items-center;

		svg {
			@apply
			yst-w-6
			yst-h-6
			yst-mr-3
			yst-text-slate-400;
		}
	}
}

.mobileMenu {
	display: none;
	@media screen and (max-width: 1024px){
		display: block;
	}
}

// Matches the `nav.desktopMenu` specificity of the layout rule above so this
// responsive display toggle wins (a bare `.desktopMenu` would lose to it and
// leave the desktop sidebar visible on mobile).
nav.desktopMenu {
	@apply
	yst-pb-1;
	display: block;

	@media screen and (max-width: 1024px){
		display: none;
	}

	div ul a {
		@apply yst-pl-4 #{!important};
	}
}

hr {
	@apply yst-mt-4 yst-mb-2 yst-border-slate-300 #{!important};

	&:first-of-type {
		@apply yst-mt-6 #{!important};
	}
}
